import { GetStatementsApiParameter } from "@bToC/Services/StatementService";
import StatementsPageState from "@bToC/Store/Pages/Statements/StatementsPageState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { Draft } from "immer";

const initialState: StatementsPageState = {
    getStatementsParameter: {
        customerSequence: "-1",
        sort : "statementDate DESC"
    },
    filtersOpen: false,
};

const reducer = {
    "CustomPages/Statements/UpdateSearchFields": (
        draft: Draft<StatementsPageState>,
        action: { parameter: GetStatementsApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getStatementsParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getStatementsParameter = { ...initialState.getStatementsParameter, ...action.parameter };
        } else {
            draft.getStatementsParameter = { ...draft.getStatementsParameter, ...action.parameter };

            for (const key in draft.getStatementsParameter) {
                const value = (<any>draft.getStatementsParameter)[key];

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getStatementsParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getStatementsParameter.page &&
                    draft.getStatementsParameter.page > 1 &&
                    key !== "page" &&
                    key !== "pageSize"
                ) {
                    draft.getStatementsParameter.page = 1;
                }
            }
        }
    },
    "CustomPages/Statements/ClearParameter": (draft: Draft<StatementsPageState>) => {
        draft.getStatementsParameter = {
            ...initialState.getStatementsParameter,
            pageSize: draft.getStatementsParameter.pageSize,
        };
    },
    "CustomPages/Statements/ToggleFiltersOpen": (draft: Draft<StatementsPageState>) => {
        draft.filtersOpen = !draft.filtersOpen;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
